import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {teamsHasMentorsById} from '/redux/selector/coach.selector';

import TeamsTab from './TeamsTab';

export default connect(
  createStructuredSelector({
    hasMentors: teamsHasMentorsById,
  }),
)(TeamsTab);
